import { Injectable } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavService {

    public currentUrl = new BehaviorSubject<any>(undefined);
    public toggleSidebar = new Subject<void>();

    constructor(private router: Router) {
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                this.currentUrl.next(event.urlAfterRedirects);
            }
        });
    }

    collapseSidebar() {
        // Trì hoãn sang tick tiếp theo để tránh NG0100
        // (child ngOnInit cập nhật width sidebar của MainLayout trong cùng CD cycle).
        setTimeout(() => this.toggleSidebar.next());
    }

}
